import { AlertTriangle } from "lucide-react";
import { useStore } from "../context/StoreContext";

const Usage = () => {
  const { t } = useStore();
  return (
    <section id="usage" className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:py-24" data-testid="usage-section">
      <h2 className="font-display mb-8 text-4xl sm:text-5xl" data-testid="usage-title">{t.usage.title}</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {t.usage.steps.map((s, i) => (
          <div key={s.title} className="card p-5" data-testid={`usage-step-${i}`}>
            <span className="accent-text font-display text-3xl">0{i + 1}</span>
            <p className="font-display mt-2 text-2xl">{s.title}</p>
            <p className="mt-1 text-sm text-[var(--muted)]">{s.desc}</p>
          </div>
        ))}
      </div>
      <p className="mt-6 flex items-start gap-2 text-xs leading-relaxed text-[var(--muted)]" data-testid="usage-warning">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        {t.usage.warning}
      </p>
    </section>
  );
};

export default Usage;
